import { Component, inject } from '@angular/core';
import { FuelProviderService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  FuelProviderCreateDto,
  FuelProviderDto,
  FuelProviderExcelDownloadDto,
  FuelProviderUpdateDto,
} from '../proxy/controlling/dtos/fuel-provider';
import { FUELPROVIDER_CONFIG, FUELPROVIDER_FIELDS } from './fuel-provider.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-fuel-provider',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, FuelProviderService, ConfirmationService],
  templateUrl: './fuel-provider.html',
  styleUrl: './fuel-provider.scss',
})
export class FuelProvider extends BaseCrudComponent<
  FuelProviderDto,
  FuelProviderCreateDto,
  FuelProviderUpdateDto,
  FuelProviderExcelDownloadDto
> {
  service = inject(FuelProviderService);
  config = FUELPROVIDER_CONFIG;
  fields = FUELPROVIDER_FIELDS;

  protected prepareUpdateDto(data: any, selected: FuelProviderDto): FuelProviderUpdateDto {
    return {
      name: data.name,
      sapCode: data.sapCode,
      oldSapCode: data.oldSapCode,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'FuelProvider';
  }
}
